/**
 * Registers a new property in the window object. This can be used to e.g. expose functions
 * via the console for testing purposes.
 *
 * Example usage for a function:
 * - Write `registerFunctionInWindow("testGetActiveVoucher", getVoucherEndDate);`
 * in a file to register `testGetActiveVoucher()`
 * - Call `testGetActiveVoucher()` in the browser console to execute `getVoucherEndDate()`
 *
 * @param {string} name the name of the window property that will store the property
 * @param {unknown} prop the property to link
 */
export function registerInWindow(name, prop) {
  if (window !== undefined) {
    window[name] = prop;
  }
}



// WEBPACK FOOTER //
// ./src/common/utilities/registerInWindow.util.js